<template>
  <el-container>
    <fhead></fhead>
    <el-main>
      <el-breadcrumb class="center" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">{{$t('l.home')}}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/blocks' }">{{$t('l.blockIndex.title')}}</el-breadcrumb-item>
        <el-breadcrumb-item>{{$t('l.blockIndex.title1')}}</el-breadcrumb-item>
      </el-breadcrumb>
      <el-card v-loading="loading" class="box-card center" style="margin-top: 16px">
        <div slot="header" class="clearfix">
          <span>{{height}}</span>
          <el-button
            @click="update(0)"
            style="float: right; padding: 3px 0"
            type="text"
          >{{$t('l.blockIndex.title2')}}</el-button>
          <el-button
            @click="update(1)"
            style="float: right; padding: 3px 0;margin-right: 20px"
            type="text"
          >{{$t('l.blockIndex.title3')}}</el-button>
        </div>

        <el-form size="mini" label-width="100px">
          <el-form-item :label="$t('l.block')+'id'">{{Blocks.block}}</el-form-item>
          <el-form-item :label="$t('l.blockIndex.height')">{{Blocks.height}}</el-form-item>
          <el-form-item
            :label="$t('l.blockIndex.date')"
          >{{$g.wallet.formatDateTime(Blocks.timestamp,($store.state.epochBeginning-500))}}</el-form-item>
          <el-form-item :label="$t('l.blockIndex.generatorRS')">
            <router-link :to="'/account/'+Blocks.generatorRS">
              <el-button style="font-size: 14px" type="text">{{Blocks.generatorRS}}</el-button>
            </router-link>
          </el-form-item>
          <el-form-item :label="$t('l.blockIndex.length')">{{Blocks.transactions.length}}</el-form-item>
          <el-form-item
            :label="$t('l.blockIndex.totalAmountNQT')"
          >{{$g.wallet.amount(Blocks.totalAmountNQT)}}</el-form-item>
          <el-form-item
            :label="$t('l.blockIndex.totalFeeNQT')"
          >{{$g.wallet.amount(Blocks.totalFeeNQT)}}</el-form-item>
        </el-form>

        <el-collapse v-model="activeNames">
          <el-collapse-item :title="$t('l.blockIndex.transactions')" name="1">
            <el-table :data="Blocks.transactions" border style="width: 100%">
              <el-table-column label="Transaction" width="280">
                <template slot-scope="scope">
                  <router-link :to="'/transaction/'+scope.row.transaction">
                    <el-button type="text">{{scope.row.transaction}}</el-button>
                  </router-link>
                </template>
              </el-table-column>
              <el-table-column :label="$t('l.senderRS')" width="280">
                <template slot-scope="scope">
                  <router-link :to="'/account/'+scope.row.senderRS">
                    <el-button type="text">{{scope.row.senderRS}}</el-button>
                  </router-link>
                </template>
              </el-table-column>
              <el-table-column :label="$t('l.recipientRS')" width="280">
                <template slot-scope="scope">
                  <router-link :to="'/account/'+scope.row.recipientRS">
                    <el-button type="text">{{scope.row.recipientRS}}</el-button>
                  </router-link>
                </template>
              </el-table-column>
              <el-table-column :label="$t('l.amountNQT')" width="180">
                <template slot-scope="scope">{{$g.wallet.amount(scope.row.amountNQT)}}</template>
              </el-table-column>
              <el-table-column :label="$t('l.feeNQT')" width="100">
                <template slot-scope="scope">{{$g.wallet.amount(scope.row.feeNQT)}}</template>
              </el-table-column>
            </el-table>
          </el-collapse-item>
        </el-collapse>
      </el-card>
    </el-main>
    <el-footer class="footer">
      COPYRIGHT © 2018. ALL RIGHTS RESERVED. DESIGNED BY
      <a
        target="_blank"
        href="https://hebeblock.com/"
      >HEBEBLOCK</a>
    </el-footer>
  </el-container>
</template>


<script>
import fhead from "../fhead.vue";
export default {
  name: "block",
  data() {
    return {
      loading: true,
      height: 0,
      Blocks: {
        transactions: []
      },
      activeNames: [0]
    };
  },
  components: {
    fhead
  },
  methods: {
    update(state) {
      if (state == 0) {
        this.height++;
      } else {
        this.height--;
      }
      this.$router.push("/block/" + this.height);
      this.load();
    },
    load() {
      this.activeNames = [0];
      this.loading = true;
      this.Blocks = {
        transactions: []
      };
      this.height = this.$route.params.height;
      if (!this.height) {
        this.$router.replace("blocks");
      }
      this.loading = true;
      this.$ajax({
        method: "get",
        url:
          "requestType=getBlock&height=" +
          this.height +
          "&includeTransactions=true"
      }).then(response => {
        console.log(response);
        if (response.errorCode) {
          this.$alert("高度错误", this.$t("l.fhead.prompt.title"), {
            confirmButtonText: this.$t("l.fhead.prompt.confirm"),
            callback: action => {
              this.$router.replace("/blocks");
            }
          });
        } else {
          this.Blocks = response;
          this.Blocks = this.$g.wallet.blocks(
            this.Blocks,
            this.$store.state.apiText
          );
          this.Blocks.transactions.forEach(item => {
            item = this.$g.wallet.transactions(item, this.$store.state.apiText);
          });
          this.loading = false;
        }
      });
    }
  },
  created: function() {
    this.load();
  },
  watch: {
    $route(to, from) {
      this.load();
    }
  }
};
</script>


<style scoped>
</style>  


// WEBPACK FOOTER //
// src/components/block/block.vue